/* Copyright (c) 2022 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum VideoPlayerStates {
    NONE,
    INITIATION,
    UNLOADED,
    LOADING,
    LOADED,
    PLAYING,
    BUFFERING,
    RATE_CHANGE,
    ERROR_RECOVERY,
    FATAL_ERROR,
    END_OF_STREAM,
    FIRST_FRAME,
    PAUSE,
    READY,
}
